module.exports = __webpack_public_path__ + "static/media/room-12.0e293352.jpeg";